module.exports = __webpack_public_path__ + "img/image38.9e62b673.png";